module.exports = "<em pTooltip=\"{{this.msgToDisplay}}\" tooltipPosition=\"{{this.positionOfMsg}}\" class=\"fa fa-info-circle remove-padd\"></em>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/tooltip/tooltip.component.html
// module id = ../../../../../src/app/shared/components/tooltip/tooltip.component.html
// module chunks = main